// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3TliK","sendOtp":"AuthorizeToLogin_sendOtp__3Ryf4"};